import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { Reveal } from './Reveal';
export function FinalCTA() {
  return <section className="w-full bg-surface px-4 py-20 text-navy sm:py-24" data-id="element-80" data-mp="3uei2ph2cts2v">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="c8c1na07knfo">
        <h2 className="font-serif text-5xl leading-tight sm:text-6xl" data-id="element-82" data-mp="84ntoq7nzptw">
          You Are the Professional
          <br data-id="element-83" data-mp="m4f5qlemew59" />
          <span className="text-amber" data-id="element-84" data-mp="m3wyktqf6xik">Your Clients Have Been Waiting For.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-slate sm:text-lg" data-id="element-85" data-mp="h6n8dbv7ihto">
          The system exists. The protocols are proven. The only question is when you choose to step
          into your professional credibility.
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-slate" data-id="element-86" data-mp="qy15xe3ll7k6">
          6 complete volumes. 5 bonus guides. A 60-page printable resource library. One organized
          system to build a thriving practice.
        </p>
        <div className="mt-10" data-id="element-87" data-mp="2c5g6u7gxf4wh">
          <Countdown dark={false} initialSeconds={11 * 3600 + 57 * 60 + 43} data-id="element-88" data-mp="2c67r4m52pg7g" />
        </div>
        <div className="mt-10" data-id="element-89" data-mp="2h4j3b3iuc2su">
          <CTAButton size="large" data-id="element-90" data-mp="2h5knpylqy1n8">🚀 GET INSTANT ACCESS — $27 USD</CTAButton>
        </div>
        <p className="mt-5 text-xs leading-6 text-slate sm:text-sm" data-id="element-91" data-mp="2m4x9sh4sn4or">
          🔒 Secure Payment · 💳 Card · 🌎 Local Currency &amp; Payment Options · ⚡ Instant Access
          · ♾️ Lifetime Access
        </p>
      </Reveal>
    </section>;
}